import React from 'react';
import { Card, Table } from 'antd';
import type { TableProps } from 'antd';

interface PropsType {
	enums?: any;
	data?: any;
	changePriceFormat?: any;
}

interface TableDataType {
	id: number;
	username?: string;
	cell_encrypt?: string;
	user_status?: number;
	role_list?: any;
	store_list?: any;
	create_time?: string;
	update_time?: string;
	start_time?: any;
	end_time?: any;
}

const RenewalDetails: React.FC<PropsType> = props => {
	const { data, changePriceFormat } = props;

	const columns: TableProps<TableDataType>['columns'] = [
		{
			title: '续租日期',
			dataIndex: 'start_time',
			key: 'start_time',
			render: (_, record) => <div>{`${record.start_time} - ${record.end_time}`}</div>,
		},
		{
			title: '车辆租金',
			dataIndex: 'rental_amount',
			key: 'rental_amount',
			render: text => changePriceFormat(text),
		},
		{
			title: '保障服务',
			dataIndex: 'guarantee_amount',
			key: 'guarantee_amount',
			render: text => changePriceFormat(text),
		},
		{
			title: '总价',
			dataIndex: 'total_amount',
			key: 'total_amount',
			render: text => changePriceFormat(text),
		},
		{
			title: '下单时间',
			dataIndex: 'create_time',
			key: 'create_time',
		},
		{
			title: '退款金额',
			dataIndex: 'refund_amount',
			key: 'refund_amount',
			render: text => (text === -1 ? '--' : changePriceFormat(text)),
		},
		{
			title: '取消扣费',
			dataIndex: 'deduct_amount',
			key: 'deduct_amount',
			render: text => (text === -1 ? '--' : changePriceFormat(text)),
		},
		{
			title: '取消时间',
			dataIndex: 'cancel_time',
			key: 'cancel_time',
		},
		{
			title: '操作人',
			dataIndex: 'operator',
			key: 'operator',
		},
	];

	return (
		<Card title="续租明细" style={{ marginTop: '20px' }}>
			<Table columns={columns} dataSource={data?.renewal_items} rowKey={cols => cols.id} pagination={false} />
		</Card>
	);
};

export default RenewalDetails;
